import Swiper, { Autoplay, Navigation, Pagination } from "swiper";

export default () => {
  Swiper.use([Navigation, Pagination, Autoplay]);

  let projectSlider;
  let quotesSlider;
  let imagesSlider;

  var createSlider = function () {
    let quotesSliders = document.querySelectorAll(
      "#quotes .swiper .swiper-slide"
    );

    let imagesSliders = document.querySelectorAll(
      "#imageCarousel .swiper .swiper-slide"
    );

    if (imagesSlider === undefined && imagesSliders.length > 1) {
      imagesSlider = new Swiper("#imageCarousel .swiper", {
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: "#imageCarousel .btn-next",
          prevEl: "#imageCarousel .btn-prev",
        },
      });
    }

    if (quotesSlider === undefined && quotesSliders.length > 1) {
      quotesSlider = new Swiper("#quotes .swiper", {
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        centeredSlides: true,
        navigation: {
          nextEl: "#quotes .btn-next",
          prevEl: "#quotes .btn-prev",
        },
        // autoplay: {
        // 	delay: 3000,
        // 	disableOnInteraction: false,
        // },
      });
    }

    let projectSliders = document.querySelectorAll(
      "#projects .swiper .swiper-slide"
    );
    if (projectSlider === undefined && projectSliders.length > 1) {
      quotesSlider = new Swiper("#projects .swiper", {
        // loop: true,
        // slidesPerView: 1,
        // centeredSlides: true,
        navigation: {
          nextEl: "#projects .btn-next",
          prevEl: "#projects .btn-prev",
        },
        breakpoints: {
          300: {
            spaceBetween: 20,
            slidesPerView: 1.4,
          },
          500: {
            spaceBetween: 10,
            slidesPerView: 2.4,
          },
          992: {
            spaceBetween: 20,
            slidesPerView: 3.4,
          },
          1440: {
            spaceBetween: 20,
            slidesPerView: 4.4,
          },
        },
      });
    }
  };

  window.addEventListener("resize", function () {
    createSlider();
  });

  createSlider();
};
